import Header from "@editorjs/header";
import LinkInline from "./vendor/inline-tool-link";
import { NestedList } from "./nested-list";
import { Quote } from "./quote";
import Table from "./vendor/table/plugin";
import { Markdown } from "./markdown";
import { CodeInline } from "./code-inline";
import { Code } from "./code";
import { Alert } from "./alert";
import { RockImage } from "./rockimage";
import { Embed } from "./embed";

export const Tools = {
    Alert,
    Code,
    CodeInline,
    Embed,
    Header,
    Image: RockImage,
    LinkInline,
    Markdown,
    NestedList,
    Quote,
    Table
}
